import { useEffect, useMemo, useState } from 'preact/hooks'

export const useCopy = () => {
  const [copied, setCopied] = useState(false)

  const setSuccess = () => {
    setCopied(true)
  }

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false)
      }, 1000)
    }
  }, [copied])

  return useMemo(() => ({
    copied,
    setSuccess,
  }), [copied])
}
